export default "__VITE_ASSET__825d190b__"